<template>
  <div class="about-container">
    <h1>About Us</h1>
    <p>Welcome to Toronto DAO</p>
    <div class="who">
      <h3>Who Are We?</h3>
      <p>
        Toronto DAO is a grassroots organization dedicated to cultivating and
        retaining tech talent in Toronto while fostering innovation across
        various technology sectors. With a focus on building a strong, inclusive
        tech community, Toronto DAO provides opportunities for collaboration in
        areas such as software development, AI, blockchain, and more. The
        organization is structured to encourage decentralized decision-making,
        enabling members to take an active role in projects ranging from tech
        education workshops to large-scale events like hackathons and
        conferences. By bridging local talent with global opportunities, Toronto
        DAO aims to make Toronto a leading hub for technological excellence,
        supporting both general tech initiatives and the growth of emerging
        sectors. Through business memberships, community-led projects, and
        strategic partnerships, the organization is building a dynamic ecosystem
        that empowers individuals and companies alike.
      </p>
      <h3>Meet the Team</h3>
      <div class="image-text-container">
        <img src="@/assets/samir.jpg" alt="Sample Image" class="image" />
        <div class="text-content">
          <h3>Samir Azizi</h3>
          <ul class="social-icons">
            <li>
              <a
                href="https://www.linkedin.com/in/samirazizi?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
                target="_blank"
              >
                <!-- LinkedIn Icon -->
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_4_212)">
                    <path
                      d="M18.5195 0H1.47656C0.660156 0 0 0.644531 0 1.44141V18.5547C0 19.3516 0.660156 20 1.47656 20H18.5195C19.3359 20 20 19.3516 20 18.5586V1.44141C20 0.644531 19.3359 0 18.5195 0ZM5.93359 17.043H2.96484V7.49609H5.93359V17.043ZM4.44922 6.19531C3.49609 6.19531 2.72656 5.42578 2.72656 4.47656C2.72656 3.52734 3.49609 2.75781 4.44922 2.75781C5.39844 2.75781 6.16797 3.52734 6.16797 4.47656C6.16797 5.42187 5.39844 6.19531 4.44922 6.19531ZM17.043 17.043H14.0781V12.4023C14.0781 11.2969 14.0586 9.87109 12.5352 9.87109C10.9922 9.87109 10.7578 11.0781 10.7578 12.3242V17.043H7.79688V7.49609H10.6406V8.80078H10.6797C11.0742 8.05078 12.043 7.25781 13.4844 7.25781C16.4883 7.25781 17.043 9.23438 17.043 11.8047V17.043V17.043Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_4_212">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </li>
            <li>
              <a
                href="https://x.com/adoublezi?s=21&t=mWVM_nh66uA5j1oEOVlN5Q"
                target="_blank"
              >
                <!-- X Icon -->
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.2719 1.58661H18.0831L11.9414 8.60619L19.1666 18.1582H13.5093L9.07834 12.365L4.00827 18.1582H1.19534L7.76451 10.65L0.833313 1.58661H6.63424L10.6395 6.88189L15.2719 1.58661ZM14.2852 16.4756H15.843L5.78781 3.18089H4.1162L14.2852 16.4756Z"
                    fill="white"
                  />
                </svg>
              </a>
            </li>
          </ul>

          <p>
            Samir Azizi is a seasoned marketing professional with a strong
            background in the crypto industry, having worked as the Marketing
            Manager for CoinSmart (acquired by WonderFI) and Country Marketing
            Manager at Bitget. He is also the co-founder of SmartCloser AI and
            serves as the Director of Artificial Intelligence at Cyber Security
            Global Alliance. Samir co-authored the professional course "ChatGPT
            for Real Estate Agents" and is the host of the popular Azizi
            Podcast, with over 700k views on YouTube.
          </p>
        </div>
      </div>
      <div class="image-text-container">
        <img src="@/assets/matthew.jpg" alt="Sample Image" class="image" />
        <div class="text-content">
          <h3>Matthew Glezos</h3>
          <ul class="social-icons">
            <li>
              <a
                href="https://www.linkedin.com/in/matthew-glezos-9027b9100?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
                target="_blank"
              >
                <!-- LinkedIn Icon -->
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_4_212)">
                    <path
                      d="M18.5195 0H1.47656C0.660156 0 0 0.644531 0 1.44141V18.5547C0 19.3516 0.660156 20 1.47656 20H18.5195C19.3359 20 20 19.3516 20 18.5586V1.44141C20 0.644531 19.3359 0 18.5195 0ZM5.93359 17.043H2.96484V7.49609H5.93359V17.043ZM4.44922 6.19531C3.49609 6.19531 2.72656 5.42578 2.72656 4.47656C2.72656 3.52734 3.49609 2.75781 4.44922 2.75781C5.39844 2.75781 6.16797 3.52734 6.16797 4.47656C6.16797 5.42187 5.39844 6.19531 4.44922 6.19531ZM17.043 17.043H14.0781V12.4023C14.0781 11.2969 14.0586 9.87109 12.5352 9.87109C10.9922 9.87109 10.7578 11.0781 10.7578 12.3242V17.043H7.79688V7.49609H10.6406V8.80078H10.6797C11.0742 8.05078 12.043 7.25781 13.4844 7.25781C16.4883 7.25781 17.043 9.23438 17.043 11.8047V17.043V17.043Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_4_212">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </li>
            <li>
              <a
                href="https://x.com/matthew_glezos?s=21&t=mWVM_nh66uA5j1oEOVlN5Q"
                target="_blank"
              >
                <!-- X Icon -->
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.2719 1.58661H18.0831L11.9414 8.60619L19.1666 18.1582H13.5093L9.07834 12.365L4.00827 18.1582H1.19534L7.76451 10.65L0.833313 1.58661H6.63424L10.6395 6.88189L15.2719 1.58661ZM14.2852 16.4756H15.843L5.78781 3.18089H4.1162L14.2852 16.4756Z"
                    fill="white"
                  />
                </svg>
              </a>
            </li>
          </ul>
          <p>
            An MBA with a traditional finance background with working experience
            in Canada and Latin America, Matthew began an interest in Web3 in
            2018, casually investing and reading up on the latest information
            wherever his professional career took him. At the start of the
            pandemic he decided to change his status in Web3 from amateur to
            professional when he enrolled in the George Brown Blockchain
            Development Program. Since then he has worked for various DeFi DAOs
            as a Business Developer before working on starting TorontoDAO.
          </p>
        </div>
      </div>
      <div class="image-text-container">
        <img src="@/assets/antoine.jpg" alt="Sample Image" class="image" />
        <div class="text-content">
          <h3>Antoine De Vuyst</h3>
          <ul class="social-icons">
            <li>
              <a
                href="https://www.linkedin.com/in/antoine-de-vuyst-49a74194?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
                target="_blank"
              >
                <!-- LinkedIn Icon -->
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_4_212)">
                    <path
                      d="M18.5195 0H1.47656C0.660156 0 0 0.644531 0 1.44141V18.5547C0 19.3516 0.660156 20 1.47656 20H18.5195C19.3359 20 20 19.3516 20 18.5586V1.44141C20 0.644531 19.3359 0 18.5195 0ZM5.93359 17.043H2.96484V7.49609H5.93359V17.043ZM4.44922 6.19531C3.49609 6.19531 2.72656 5.42578 2.72656 4.47656C2.72656 3.52734 3.49609 2.75781 4.44922 2.75781C5.39844 2.75781 6.16797 3.52734 6.16797 4.47656C6.16797 5.42187 5.39844 6.19531 4.44922 6.19531ZM17.043 17.043H14.0781V12.4023C14.0781 11.2969 14.0586 9.87109 12.5352 9.87109C10.9922 9.87109 10.7578 11.0781 10.7578 12.3242V17.043H7.79688V7.49609H10.6406V8.80078H10.6797C11.0742 8.05078 12.043 7.25781 13.4844 7.25781C16.4883 7.25781 17.043 9.23438 17.043 11.8047V17.043V17.043Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_4_212">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </li>
            <li>
              <a
                href="https://x.com/walalaaaaa?s=21&t=mWVM_nh66uA5j1oEOVlN5Q"
                target="_blank"
              >
                <!-- X Icon -->
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.2719 1.58661H18.0831L11.9414 8.60619L19.1666 18.1582H13.5093L9.07834 12.365L4.00827 18.1582H1.19534L7.76451 10.65L0.833313 1.58661H6.63424L10.6395 6.88189L15.2719 1.58661ZM14.2852 16.4756H15.843L5.78781 3.18089H4.1162L14.2852 16.4756Z"
                    fill="white"
                  />
                </svg>
              </a>
            </li>
          </ul>
          <p>
            Antoine De Vuyst is a seasoned Ethereum and Blockchain developer,
            active in the crypto world since 2011. As a co-founder of Bitcoin
            Bay, Ucash, BumbleBeeExchange, and BitBars, he has played a key role
            in driving several blockchain initiatives forward. Antoine is well
            known for his contributions to the Toronto blockchain community,
            having developed a range of decentralized applications (dApps),
            including wallet apps, DeFi platforms, and bounty apps. His
            technical expertise spans Python, Solidity, JavaScript, HTML5, and
            full-stack development. Antoine’s commitment to fostering blockchain
            innovation and supporting the Toronto tech community remains central
            to his work.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.about-container {
  padding-top: 150px;
  text-align: center;
}

.who {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
}

.who h3 {
  font-size: 50px;
  margin-bottom: 20px;
}

.who p {
  max-width: 800px;
  font-size: 18px;
  line-height: 1.6;
  text-align: justify;
}

.image-text-container {
  display: flex;
  align-items: center;
  gap: 20px; /* Space between the image and text */
  margin: 20px auto;
  max-width: 900px;
  text-align: left;
}

.image {
  width: 40%; /* Adjust as per requirement */
  max-width: 300px; /* Ensures the image doesn't exceed this size */
  border-radius: 8px; /* Adds rounded corners */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Adds subtle shadow */
}

.text-content {
  flex: 1; /* Takes up remaining space */
}

.text-content h3 {
  font-size: 24px;
  margin-bottom: 10px;
}

.text-content p {
  font-size: 16px;
  line-height: 1.6;
}
.social-icons {
  display: flex;
  gap: 10px;
  margin-top: 10px;
  list-style: none;
  padding-left: 0px;
}

.social-icons a {
  display: block;
  width: 20px;
  height: 20px;
}

.social-icons a svg {
  width: 100%;
  height: 100%;
}

.social-icons a:hover svg {
  opacity: 0.7;
}
</style>
